import { HttpClient } from '@angular/common/http';
import {  inject } from "@angular/core";
import { Observable } from 'rxjs';
import { AppDataService } from './app-data.service';



export abstract class BaseService {

    
    public get apiURL(): string {
        return `${this.appDataService.configurations.rootApiUrl}/api${this.subUrl}`;
    }

    public get dmsURL(): string {
        return `${this.appDataService.configurations.rootDmsUrl}${this.subUrl}`;
    }

    public get absoluteHostNameURL(): string {
        return this.appDataService.configurations.rootUrl;
    }

    public readonly idsURL: string | null = null;

    protected http: HttpClient = inject(HttpClient);
    protected appDataService: AppDataService= inject(AppDataService);
    
    constructor(protected subUrl: string = "") {}


    public request<T>(apiName: string, body?: object, method: string = "post", rootUrl: string = this.apiURL,options = {}, allowBusinessErrorToaster: string = 'allow'): Observable<T> {

        const header = { ...(options as { headers: object })?.headers, 'allow-business-error-toaster': allowBusinessErrorToaster, }
        return this.http.request<T>(method, `${rootUrl}/${apiName}`, {
            ...options, body: body, headers: header
        });
    }

    public requestDms<T>(url: string, body?: object, method: string = "post", options = {}, allowBusinessErrorToaster: string = 'allow'): Observable<T> {

        const header = { ...(options as { headers: object })?.headers, 'allow-business-error-toaster': allowBusinessErrorToaster, }
        return this.http.request<T>(method, `${this.dmsURL}/${url}`, {
            ...options, body: body, headers: header
        });

    }

    public requestbyUrl<T>(url: string , body?: object, method: string = "post", options = {}, allowBusinessErrorToaster: string = 'allow'): Observable<T> {

        const header = { ...(options as { headers: object })?.headers, 'allow-business-error-toaster': allowBusinessErrorToaster, }
        return this.http.request<T>(method, `${this.appDataService.configurations.rootApiUrl}/api/${url}`, {
            ...options, body: body, headers: header
        });

    }    

    public post<T>(body: object, options = {}): Observable<T> {
        return this.http.post<T>(this.apiURL, body, options);
    }

    public save<T>(body: object, options = {}): Observable<T> {
        return this.http.post<T>(`${this.apiURL}/Save`, body, options);
    }

    public delete(id: string | number): Observable<any> {
        return this.http.delete<any>(`${this.apiURL}/Delete`, { body: { data: id } });
    }

    public get(body = {}): Observable<any> {
        return this.http.post<any>(`${this.apiURL}/Get`, body);
    }

}
